import { render } from "./product-category.vue?vue&type=template&id=12c9a499&scoped=true"
import script from "./product-category.vue?vue&type=script&lang=js"
export * from "./product-category.vue?vue&type=script&lang=js"

import "./product-category.vue?vue&type=style&index=0&id=12c9a499&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c9a499"]])

export default __exports__